import { render, staticRenderFns } from "./pinggu-introduce.vue?vue&type=template&id=e1fd7798&scoped=true&"
import script from "./pinggu-introduce.vue?vue&type=script&lang=ts&"
export * from "./pinggu-introduce.vue?vue&type=script&lang=ts&"
import style0 from "./pinggu-introduce.vue?vue&type=style&index=0&id=e1fd7798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fd7798",
  null
  
)

export default component.exports